import { debug, type InitialState } from '@schibsted-nmp/advertising-shared';

export function getInitialState() {
  try {
    const jsonScript = document.getElementById('advertising-initial-state');

    if (jsonScript) {
      return JSON.parse(jsonScript.innerHTML) as InitialState;
    }

    debug.message('Initial state script not found!').warn();

    return null;
  } catch (error) {
    debug.message('Failed parsing initial state!', error).error();
  }

  return null;
}

export function hasInitialPlacements(initialState: InitialState) {
  const result = initialState.config.placements.length > 0;

  if (!result) {
    debug.message('No placements exist in initial state!').warn();
  }

  return result;
}
